import emailjs from '@emailjs/browser';

export const sendEmail = async (data) => {
  try {
    const response = await emailjs.send(
      import.meta.env.VITE_EMAILJS_SERVICE_ID,
      import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
      {
        from_name:    data.name,
        from_email:   data.email,
        phone:        data.phone || 'Not provided',
        role:         data.role,
        tier:         data.tier || data.level,
        goal:         data.goal || data.intent || 'Not specified',
        submitted_at: new Date().toISOString(),
      },
      import.meta.env.VITE_EMAILJS_PUBLIC_KEY
    );
    return response;
  } catch (error) {
    console.error('EmailJS failed:', error);
    throw error;
  }
};

// Alias for backwards compatibility
export const sendInquiryEmail = sendEmail;